import React, { useState, useEffect, useRef } from "react";
import Navbar from "./navbar";
import About from "./about";
import Resume from "./resume";
import Projects from "./projects";
import Contact from "./contact";

export default function Body() {
  const [navlink, setNavlink] = useState("about");
  const scrollRef = useRef(null);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    let timeoutId;
    const handleScroll = () => {
      el.classList.add("is-scrolling");
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        el.classList.remove("is-scrolling");
      }, 1000);
    };

    el.addEventListener("scroll", handleScroll, { passive: true });
    return () => {
      el.removeEventListener("scroll", handleScroll);
      clearTimeout(timeoutId);
    };
  }, []);

  return (
    <div className="glass-panel p-6 sm:p-8 lg:p-10 rounded-3xl h-full flex flex-col relative glow-teal min-h-0 w-full">
      <Navbar setNavlink={setNavlink} />
      <div
        ref={scrollRef}
        className="flex-1 overflow-y-auto min-h-0 lg:pt-16 pb-20 lg:pb-0 hide-scrollbar-inactive"
      >
        {navlink === "about" && <About />}
        {navlink === "resume" && <Resume />}
        {navlink === "projects" && <Projects />}
        {navlink === "contact" && <Contact />}
      </div>
    </div>
  );
}
